import { Injectable } from '@angular/core';
import { User } from '../core/user';
import { protectedResources } from '../auth-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
    apiEndpoint =  protectedResources.ROARFunctionApp.endpoint;
    user : User = new User()

constructor(private http: HttpClient) { }

  getUserName() {
    return this.user.displayName;
  }

  getSystemId() {
    return 'ROAR.CustomerRefund.Portal';
  }

  getUserId() {
    return this.user?.eid?.toUpperCase();
  }

  getEmailId() {
    return this.user.email;
  }

  getRoles() {
    return this.user.roles;
  }

  LoginROARAPI() :Observable<any> { 
   const endpoint = this.apiEndpoint + 'api/v1/CreateUserIfNotExists';
    const httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*'      
      })
    }
    return this.http.post<any>(endpoint, null, httpOptions).pipe(catchError((err)=>{
 
      console.log('error caught in service')
      console.error(err);
 
      //Handle the error here
 
      return throwError(()=>new Error(err))
 
     }))
 ;
  }


  hasAccess(roles:string[]){
    if (this.user.roles === null || this.user.roles === undefined || this.user.roles.length === 0) {
      return false;
    }
    return this.user.roles.some(role=>roles.includes(role));
   
  }
  IsReadOnlyUser():boolean
  {
    if(this.user.roles.filter(x=>x.startsWith("Auth")  ) !== undefined && this.user.roles.filter(x=>x.startsWith("Auth")  ).length === 1  && this.user.roles.findIndex(x=>x ==="AuthReadOnly") !== -1 )
      return true;
      else
      return false;

  }

  checkRoleAccess(role:string)
  {
    if (this.user.roles === null || this.user.roles === undefined || this.user.roles.length === 0) {
      return false;
    }
    console.log (this.user.roles);
    return this.user.roles.map( v => v.toLowerCase()).includes(role.toLowerCase());

  }

  

}
